import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { NC_WEBSITE, SCT_WEBSITE } from '../../../lib/constants';
import { ApplicationService } from '../../../lib/services/application.service';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class PrivacyComponent implements OnInit {
  private applicationService = inject(ApplicationService);

  applicationName: string
  isNextComunica: boolean
  urlWebsite: string

  constructor() {
    this.applicationName = this.applicationService.getApplicationName()
    this.applicationService.isNextComunica() ? this.urlWebsite = NC_WEBSITE : SCT_WEBSITE
  }

  ngOnInit(): void {
  }

}
